var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.3,
    height: 21.967,
    viewBox: "0 0 13.3 21.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-480.293 -287.879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.942,309.7a.542.542,0,0,1-.426-.208,35.575,35.575,0,0,1-3.03-4.749,29.977,29.977,0,0,1-2.085-4.784,17.542,17.542,0,0,1-.958-5.425,6.5,6.5,0,0,1,13,0,17.58,17.58,0,0,1-.958,5.425,29.977,29.977,0,0,1-2.085,4.784,35.708,35.708,0,0,1-3.03,4.749.542.542,0,0,1-.426.208Zm0-20.583a5.423,5.423,0,0,0-5.417,5.417c0,3.525,1.585,7.219,2.915,9.7a37.29,37.29,0,0,0,2.5,4.019,37.171,37.171,0,0,0,2.511-4.038c1.325-2.472,2.905-6.16,2.905-9.678A5.423,5.423,0,0,0,486.942,289.112Z",
    transform: "translate(0 0)",
    fill: "#e92f61",
    stroke: "#e52431",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.692,297.529a3.25,3.25,0,1,1,3.25-3.25A3.254,3.254,0,0,1,486.692,297.529Zm0-5.417a2.167,2.167,0,1,0,2.167,2.167A2.168,2.168,0,0,0,486.692,292.112Z",
    transform: "translate(0.25 0.25)",
    fill: "#e92f61",
    stroke: "#e52431",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.307234635dd4f90d94e833d337cde7a5.svg";
export { ForwardRef as ReactComponent };